import styles from "../../index.module.scss";
import { changeTime } from "./Recieved_Message";
import { useContext } from "react";
import { UserContext } from "../../../../contexts/UserContext/UserContextProvider";
import { NameAvatar } from "../../../nameImage";


export const SendMessage = ({ messageData }) => {
  const { user } = useContext(UserContext);

  return (
    <div className={styles.chat__messages__right}>
      <div className={styles.chat__messages__right__img}>
        {user.photoURL ? (
          <img src={user.photoURL} alt="user" />
        ) : (
          <NameAvatar
            width={"3.125rem"}
            height={"3.125rem"}
            firstName={user.displayName.split(" ")[0]}
            lastName={user.displayName.split(" ")[1]}
            size={"1rem"}
          />
        )}
      </div>
      <div className={styles.chat__messages_right__text_container}>
        <div className={styles.chat__messages__right__text}>
          <p>{messageData.message}</p>
          <div className={styles.chat__messages__right__text__timing}>
            <span>{changeTime(messageData.createdAt)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export const SendMessageAgain = ({ messageData }) => {
  return (
    <div className={styles.chat__message__right__again}>
      <div className={styles.chat__messages_right__text_container__again}>
        <div className={styles.chat__messages__right__text__again}>
          <p>{messageData.message}</p>
          <div className={styles.chat__messages__right__text__timing}>
            <span>{changeTime(messageData.createdAt)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
